export default __webpack_public_path__ + "static/media/ai-design-images-sample.34ccdc53.png";